import React from 'react';
import './StructuralEngineering.css';

const StructuralEngineering = () => {
  const services = [
    {
      id: 1,
      title: "Structural Design and Analysis",
      items: [
        { title: "New Structure Design", description: "Custom design for residential, commercial, and industrial buildings." },
        { title: "Seismic and Wind Load Analysis", description: "Design for resilience against natural forces." },
        { title: "Foundation Design", description: "Solutions considering soil conditions and structural requirements." },
        { title: "Retrofitting and Rehabilitation", description: "Services for strengthening existing structures." },
        { title: "Load-Bearing Analysis", description: "Calculation of loads for various conditions." },
        { title: "Finite Element Analysis (FEA)", description: "Advanced modelling for complex structures." }
      ]
    },
    {
      id: 2,
      title: "Construction Support Services",
      items: [
        { title: "3D Modeling and BIM", description: "Detailed structural models for enhanced project planning." },
        { title: "Steel Frame and Concrete Structure Detailing", description: "Comprehensive design and detailing." },
        { title: "Construction Administration", description: "Overseeing compliance with design specifications." },
        { title: "Field Services", description: "On-site engineering support during critical phases." },
        { title: "BIM Coordination", description: "Integration of structural designs and clash detection." }
      ]
    },
    {
      id: 3,
      title: "Temporary Structures and Shoring Design",
      items: [
        { title: "Scaffolding and Shoring", description: "Design of temporary structures for safe construction." },
        { title: "Formwork Design", description: "Creating safe formwork designs for complex concrete structures." },
        { title: "Crane Foundations", description: "Engineering support for safe lifting operations." }
      ]
    },
    {
      id: 4,
      title: "Specialized Material Consulting",
      items: [
        { title: "High-Performance Materials", description: "Consulting on sustainable and advanced composites." },
        { title: "Lightweight Structures", description: "Design for unique structures like stadiums and arenas." }
      ]
    },
    {
      id: 5,
      title: "Advanced Structural Analysis and Consulting",
      items: [
        { title: "Performance-Based Design", description: "Custom designs for high-rise or mission-critical structures." },
        { title: "Dynamic and Vibration Analysis", description: "Analyzing structural response to dynamic loads." },
        { title: "Progressive Collapse Analysis", description: "Preventing chain-reaction collapses in case of failures." }
      ]
    },
    {
      id: 6,
      title: "Building Code Compliance and Permitting",
      items: [
        { title: "Regulatory Compliance Consulting", description: "Ensuring designs meet all building codes." },
        { title: "Permit Preparation", description: "Assistance with documentation and permit applications." }
      ]
    },
    {
      id: 7,
      title: "Structural Health Monitoring and Maintenance",
      items: [
        { title: "Condition Assessment", description: "Routine inspections and monitoring of structures." },
        { title: "Vibration Monitoring", description: "Using sensors to detect structural issues." },
        { title: "Corrosion Protection", description: "Solutions to prevent structural degradation." }
      ]
    },
    {
      id: 8,
      title: "Sustainable and Green Building Design",
      items: [
        { title: "Green Building Design", description: "Structural designs focused on sustainability and energy efficiency." },
        { title: "Eco-friendly Materials", description: "Integration of sustainable building materials." }
      ]
    },
    {
      id: 9,
      title: "Engineering Consultation",
      items: [
        { title: "Feasibility Studies", description: "Assessing project viability and cost estimation." },
        { title: "Value Engineering", description: "Cost-effective solutions without compromising safety." },
        { title: "Risk Assessment", description: "Identifying and mitigating potential structural risks." }
      ]
    }
  ];

  return (
    <>
      {/* Page Header */}
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>Structural Engineering</h2>
            </div>
          </div>
        </div>
      </div>

      {/* Structural Engineering Services Section */}
      <div className="structural-services">
        <div className="container">
          <div className="row">
            {services.map((service) => (
              <div key={service.id} className="col-lg-6 col-md-12">
                <div className="service-item">
                  <div className="service-header">
                    <div className="service-number">{String(service.id).padStart(2, '0')}</div>
                    <h3>{service.title}</h3>
                  </div>
                  <div className="service-content">
                    <ul>
                      {service.items.map((item, index) => (
                        <li key={index}>
                          <strong>{item.title}:</strong> {item.description}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default StructuralEngineering;